<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  mounted() {
    const savedTheme = localStorage.getItem("theme");
    // Por defecto es dark si no hay registro
    const theme = savedTheme ? savedTheme : "dark";
    
    document.documentElement.setAttribute("data-theme", theme);
    if (this.$vuetify) {
      this.$vuetify.theme.dark = (theme === "dark");
    }
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

/* ── Reset global del sistema y Variables CSS ── */
*, *::before, *::after {
  box-sizing: border-box;
}

:root {
  /* =========================================
     LIGHT MODE TOKENS
     ========================================= */
  --sys-bg: #f8fafc;
  --sys-card-bg: rgba(255, 255, 255, 0.95);
  --sys-card-border: rgba(123, 47, 247, 0.15);
  --sys-dialog-bg: #ffffff;
  --sys-text-primary: #1e293b;
  --sys-text-secondary: #64748b;
  --sys-table-header: #f1f5f9;
  --sys-table-row: #ffffff;
  --sys-table-row-hover: rgba(123, 47, 247, 0.08);
  --sys-drawer-bg: #ffffff;
  --sys-drawer-active: rgba(123, 47, 247, 0.1);
  --sys-input-bg: rgba(0, 0, 0, 0.04);
}

[data-theme="dark"] {
  /* =========================================
     DARK MODE TOKENS
     ========================================= */
  --sys-bg: #0a0a12;
  --sys-card-bg: rgba(15, 10, 28, 0.85);
  --sys-card-border: rgba(123, 47, 247, 0.18);
  --sys-dialog-bg: #12101e;
  --sys-text-primary: #ffffff;
  --sys-text-secondary: rgba(255, 255, 255, 0.65);
  --sys-table-header: #1a102e;
  --sys-table-row: rgba(15, 10, 28, 0.6);
  --sys-table-row-hover: rgba(123, 47, 247, 0.15);
  --sys-drawer-bg: #0f0a1c;
  --sys-drawer-active: rgba(123, 47, 247, 0.15);
  --sys-input-bg: rgba(255, 255, 255, 0.05);
}

body, html {
  font-family: 'Inter', sans-serif !important;
  background-color: var(--sys-bg) !important;
  color: var(--sys-text-primary) !important;
  margin: 0;
  padding: 0;
}

/* Vuetify v-app override */
.v-application {
  font-family: 'Inter', sans-serif !important;
  background-color: var(--sys-bg) !important;
}

.v-application--wrap {
  background-color: var(--sys-bg) !important;
  min-height: 100vh;
}

/* ── Scrollbar dark ── */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: var(--sys-bg);
}
::-webkit-scrollbar-thumb {
  background: rgba(123, 47, 247, 0.4);
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(123, 47, 247, 0.7);
}

/* ────────────────────────────────────────────
   GLOBAL THEME OVERRIDES — Vuetify portals
   (menus, dropdowns, autocompletes, selects)
   Estos elementos Vuetify se renderizan fuera
   del scope del componente, por eso van aquí.
──────────────────────────────────────────── */

/* Fondo del menú desplegable */
[data-theme="dark"] .v-menu__content,
[data-theme="dark"] .v-autocomplete__content {
  background: var(--sys-table-header) !important;
  border: 1px solid var(--sys-card-border) !important;
  border-radius: 12px !important;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6) !important;
}

/* Lista dentro del menú */
[data-theme="dark"] .v-menu__content .v-list,
[data-theme="dark"] .v-menu__content .v-list-item,
[data-theme="dark"] .v-autocomplete__content .v-list,
[data-theme="dark"] .v-autocomplete__content .v-list-item {
  background: transparent !important;
  color: var(--sys-text-primary) !important;
  font-family: 'Inter', sans-serif !important;
}

/* Hover de items */
[data-theme="dark"] .v-menu__content .v-list-item:hover,
[data-theme="dark"] .v-autocomplete__content .v-list-item:hover {
  background: var(--sys-drawer-active) !important;
}

/* Item activo/seleccionado */
[data-theme="dark"] .v-menu__content .v-list-item--active,
[data-theme="dark"] .v-autocomplete__content .v-list-item--active {
  background: rgba(123, 47, 247, 0.25) !important;
  color: #c4a0ff !important;
}

/* Texto del item */
[data-theme="dark"] .v-menu__content .v-list-item__title,
[data-theme="dark"] .v-menu__content .v-list-item__subtitle {
  color: var(--sys-text-primary) !important;
}

/* Select / Combobox input text */
[data-theme="dark"] .v-select__selection,
[data-theme="dark"] .v-select__selection--comma {
  color: var(--sys-text-primary) !important;
  font-family: 'Inter', sans-serif !important;
}

/* Cards de dialogs de Vuetify (globales) */
[data-theme="dark"] .v-dialog .v-card {
  background: var(--sys-dialog-bg) !important;
  border: 1px solid var(--sys-card-border) !important;
  border-radius: 16px !important;
  color: var(--sys-text-primary) !important;
}
[data-theme="dark"] .v-dialog .v-card .v-card__title {
  color: var(--sys-text-primary) !important;
  font-family: 'Inter', sans-serif !important;
  font-weight: 700 !important;
}
[data-theme="dark"] .v-dialog .v-card .v-card__text {
  color: var(--sys-text-secondary) !important;
  font-family: 'Inter', sans-serif !important;
}


</style>
